const pagesOperationEventsEn = {
  detail: {
    anchorDate: 'Start Date',
    tabs: {
      data: 'Data',
      manual: 'Manual',
      operationActivity: 'Operation Activity',
      steps: 'Steps'
    },
    task: 'Task',
    title: 'Operation Event'
  },
  filters: {
    eventType: {
      label: 'Event Type',
      noResults: 'No results found',
      searchPlaceholder: 'Search event types'
    },
    pattern: {
      label: 'Pattern',
      noResults: 'No results found',
      searchPlaceholder: 'Search patterns'
    },
    status: {
      all: 'All',
      archived: 'Archived',
      completed: 'Completed',
      inProgress: 'In Progress',
      label: 'Status'
    }
  },
  list: {
    startNew: 'Start New',
    tabs: {
      archive: 'Archive',
      config: 'Config',
      events: 'Events',
      operationActivity: 'Operation Activity',
      overview: 'Overview',
      ruleAndPolicy: 'Rule & Policy',
      settings: 'Settings'
    }
  },
  startDialog: {
    eventStarted: 'Operation event has started',
    selectEventType: {
      label: 'Event Type',
      loading: 'Loading...'
    },
    selectPattern: {
      label: 'Pattern',
      loading: 'Loading...'
    },
    selectTarget: {
      anchorDate: 'Anchor Date',
      label: 'Target',
      searchPlaceholder: 'Search for target',
      selectedCount: 'Selected: {{count}}'
    },
    selectedPattern: 'Selected Pattern:',
    startButton: 'Start New',
    title: 'Start New'
  },
  stepDrawer: {
    close: 'Close',
    fetchError: 'Failed to fetch operation step',
    noTasks: 'No tasks available',
    step: 'Step'
  },
  stepFlow: {
    noSteps: 'No operation steps available'
  },
  table: {
    actions: {
      details: 'Details'
    },
    collapse: 'Collapse',
    expand: 'Expand',
    headers: {
      anchorDate: 'Anchor Date',
      event: 'Event',
      status: 'Status',
      stepProgress: 'Step Progress',
      taskProgress: 'Task Progress'
    },
    instanceCount: '{{count}} instances'
  }
};
export default pagesOperationEventsEn;